module.exports = __webpack_public_path__ + "static/media/6.12_preview.e9c7bf8d.png";